import { Injectable } from '@angular/core';
import { UserSubject } from 'src/app/model/userSubject.model';
import { Question } from 'src/app/model/question.model';
import { Subject } from 'src/app/model/subject.model';
import { CompletedQuestion } from 'src/app/model/completedQuestion.model';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ValueStoreService {

  private isItemPremium = false;

  private articlePagination: number = 0;
  private paginationMap:  Map<string, number> =  new Map<string, number>();;
  private productPagination: number = 0;
  private casestudyPagination: number = 0;

  private isSetScrollToBookListView = false;
  private isSetScrollToCaseStudyListView = false;

  private previousPage: string = null;
  private paramValue: string = null;

  private userSubjects: UserSubject[] = [];
  private correctQuestions: CompletedQuestion[] = [];

  private name: string = '';

  constructor() { }

  public setItemPremium(isPremium: boolean):void {
    this.isItemPremium = isPremium;
  }

  public getItemPremium():boolean {
    return this.isItemPremium;
  }

  public setArticlePagination(paginationNum: number){
    this.articlePagination = paginationNum;
  }

  public getArticlePagination(){
    return this.articlePagination;
  }

  public setRecentPaginationNum(key: string, paginationNum: number){
    this.paginationMap.set(key, paginationNum);
  }

  public getRecentPaginationNum(key: string){
    return this.paginationMap.get(key);
  }


  public setCasestudyPagination(paginationNum: number){
    this.casestudyPagination = paginationNum;
  }

  public getCasestudyPagination(){
    return this.casestudyPagination;
  }

  public setProductPagination(paginationNum: number){
    this.productPagination = paginationNum;
  }

  public getProductPagination(){
    return this.productPagination;
  }

  public setScrollToBookListView(isSetScrollToBookList: boolean){
    this.isSetScrollToBookListView = isSetScrollToBookList;
  }

  public isScrollToBookListView():boolean {
    return this.isSetScrollToBookListView;
  }

  public setScrollToCaseStudyListView(isSetScrollToCaseStudyListView: boolean){
    this.isSetScrollToCaseStudyListView = isSetScrollToCaseStudyListView;
  }

  public isScrollToCaseStudyListView():boolean {
    return this.isSetScrollToCaseStudyListView;
  }

  public getPreviousPage():string {
    return this.previousPage;
  }

  public setPreviousPage(previousPage:string):void {
    this.previousPage =  previousPage;
  }

  public getParamValue():string {
    return this.paramValue;
  }

  public setParamValue(paramValue:string): void {
    this.paramValue = paramValue;
  }


  public addUserSubjectToXPList(subjectId: number, questionId: number, submittedCode?: string,  xp?: number) {
      const result =  this.userSubjects.find(data => {return data.subject.id == subjectId});
      if (_.isEmpty(result)) {
         let userSubject = new UserSubject();
         userSubject.subject = new Subject(subjectId);
         let completedQuestion: CompletedQuestion[] = [];
         userSubject.completedQuestions = completedQuestion;
         userSubject.completedQuestions.push(this.createCompletedQuestion(questionId, submittedCode, xp));
         this.userSubjects.push(userSubject);
         window.sessionStorage.setItem('XPList', JSON.stringify( this.userSubjects));
      } else {
          result.completedQuestions.push(this.createCompletedQuestion(questionId, submittedCode, xp));
          window.sessionStorage.setItem('XPList', JSON.stringify( this.userSubjects));
      }
      console.log("addUserSubjectToXPList new subject"+JSON.stringify( this.userSubjects));
    }

    public getUserSubjectsWithXPFromSession():UserSubject[] {
      const userSubjects = window.sessionStorage.getItem('XPList');
      const userSubjectList:UserSubject[]   = userSubjects ? JSON.parse(userSubjects) : null;
      return userSubjectList;
    }

    public clearUserSubjectsWithXPFromSession(): void {
      window.sessionStorage.setItem('XPList', null);
    }

    public createCompletedQuestion(questionId: number, submittedCode?: string, xp?: number):CompletedQuestion {
        let question: Question = new Question();
        question.id = questionId;
        question.experiencePoint = xp;

        let completedQuestion: CompletedQuestion = new CompletedQuestion();
        completedQuestion.question= question;

        if(submittedCode !=null) {
          completedQuestion.submittedCode = submittedCode;
        }

        return completedQuestion;
     }

}
